module.exports = __webpack_public_path__ + "img/icon (5).7315aec6.png";